import { cn } from '../../lib/cn';

export default function ProgressBar({
  value = 0,
  max = 100,
  className,
  showLabel = false,
  size = 'md',
  variant = 'default',
}) {
  const percentage = Math.min(Math.max((value / max) * 100, 0), 100);

  const sizes = {
    sm: 'h-1',
    md: 'h-2',
    lg: 'h-3',
  };

  const variants = {
    default: 'bg-gray-900 dark:bg-white',
    success: 'bg-green-500',
    accent: 'bg-gradient-to-r from-gray-700 to-gray-900 dark:from-gray-300 dark:to-white',
  };

  return (
    <div className={cn('w-full', className)}>
      <div
        className={cn(
          'w-full bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden',
          sizes[size]
        )}
      >
        <div
          className={cn(
            'h-full rounded-full transition-all duration-300 ease-out',
            variants[variant]
          )}
          style={{ width: `${percentage}%` }}
          role="progressbar"
          aria-valuenow={value}
          aria-valuemin={0}
          aria-valuemax={max}
        />
      </div>
      {showLabel && (
        <div className="mt-1 text-xs text-gray-500 dark:text-gray-400 text-right">
          {Math.round(percentage)}%
        </div>
      )}
    </div>
  );
}

export function StepProgressBar({
  currentStep,
  totalSteps,
  stepLabels = [],
  className,
}) {
  const percentage = ((currentStep - 1) / (totalSteps - 1)) * 100;

  return (
    <div className={cn('w-full', className)}>
      <div className="w-full bg-gray-200 dark:bg-gray-700 h-1 rounded-full overflow-hidden">
        <div
          className="h-full bg-gray-900 dark:bg-white rounded-full transition-all duration-500 ease-out"
          style={{ width: `${percentage}%` }}
        />
      </div>
      {stepLabels.length > 0 && (
        <div className="flex justify-between mt-2 text-xs text-gray-500 dark:text-gray-400">
          {stepLabels.map((label, index) => (
            <span
              key={index}
              className={cn(
                'transition-colors duration-200',
                index < currentStep ? 'text-gray-900 dark:text-white font-medium' : ''
              )}
            >
              {label}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
